<template>
	<div class="preloader">
		<div class="preloader-aligner">
			<div class="preloader-wrapper active">
				<div class="spinner-layer">
					<div class="circle-clipper left">
					<div class="circle" style="border-width: 10px;"></div>
					</div>
					<div class="gap-patch">
					<div class="circle"></div>
					</div>
					<div class="circle-clipper right">
					<div class="circle" style="border-width: 10px;"></div>
					</div>
				</div>
			</div>
		</div>
		<img v-if="brandEnabled" :src="brandIcon" :alt="brandName"/>
		<svg-archie v-else class="archie-icon"/>
	</div>
</template>

<script>
export default {
	data () {
		const brandEnabled = this.$appData('accountData.brand.enabled') && this.$appData('accountData.brand.icon');
		return {
			brandEnabled,
			brandIcon: brandEnabled && this.$appData('accountData.brand.icon'),
			brandName: brandEnabled && this.$appData('accountData.brand.name'),
		}
	},
}
</script>

<style lang="scss">
.preloader {
	position: relative;

	svg,
	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: lighten(#41495B, 30%);
		&:not(.archie-icon) {
			max-width: 192px;
		}
	}
}

.circle-clipper,
.gap-patch {
	overflow: hidden;
	border-color: inherit;
}
.circle,
.circle-clipper,
.gap-patch,
.preloader,
.preloader-wrapper,
.spinner-layer {
	font-size: 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.preloader-aligner {
	display: flex;
	justify-content: center;
}

.preloader-wrapper {
	width: 240px;
	height:240px;
	display: inline-block;
	position: relative;
	animation: container-rotate 1568ms linear infinite;
}
.gap-patch,
.spinner-layer {
	position: absolute;
	height: 100%;
}
@keyframes container-rotate {
	to {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.spinner-layer {
	width: 100%;
	opacity: 0;
	border-color: lighten(#41495B, 30%);
}
.active .spinner-layer {
	opacity: 1;
	animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
@keyframes fill-unfill-rotate {
	12.5% {
		-webkit-transform: rotate(135deg);
		transform: rotate(135deg);
	}
	25% {
		-webkit-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	37.5% {
		-webkit-transform: rotate(405deg);
		transform: rotate(405deg);
	}
	50% {
		-webkit-transform: rotate(540deg);
		transform: rotate(540deg);
	}
	62.5% {
		-webkit-transform: rotate(675deg);
		transform: rotate(675deg);
	}
	75% {
		-webkit-transform: rotate(810deg);
		transform: rotate(810deg);
	}
	87.5% {
		-webkit-transform: rotate(945deg);
		transform: rotate(945deg);
	}
	to {
		-webkit-transform: rotate(1080deg);
		transform: rotate(1080deg);
	}
}
.gap-patch {
	top: 0;
	left: 45%;
	width: 10%;
}
.gap-patch .circle {
	width: 1000%;
	left: -450%;
}
.circle-clipper {
	display: inline-block;
	position: relative;
	width: 50%;
	height: 100%;
}
.circle-clipper .circle {
	width: 200%;
	height: 100%;
	border-style: solid;
	border-color: inherit;
	border-bottom-color: transparent !important;
	border-radius: 50%;
	-webkit-animation: none;
	animation: none;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
}
.circle-clipper.left .circle {
	left: 0;
	border-right-color: transparent !important;
	-webkit-transform: rotate(129deg);
	transform: rotate(129deg);
}
.circle-clipper.right .circle {
	left: -100%;
	border-left-color: transparent !important;
	-webkit-transform: rotate(-129deg);
	transform: rotate(-129deg);
}
.active .circle-clipper.left .circle {
	animation: left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
.active .circle-clipper.right .circle {
	animation: right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
@keyframes left-spin {
	from,
	to {
		-webkit-transform: rotate(130deg);
		transform: rotate(130deg);
	}
	50% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg);
	}
}
@keyframes right-spin {
	from,
	to {
		-webkit-transform: rotate(-130deg);
		transform: rotate(-130deg);
	}
	50% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg);
	}
}
</style>